import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_2 = { class: "h-text-center h-mb-20" }
const _hoisted_3 = { class: "b-base-title h-mt-10" }
const _hoisted_4 = { class: "h-flex h-flex-center h-width-100p h-pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      "max-width": _ctx.isDesktop() ? "450px" : "calc(100% - 20px)",
      width: "90%",
      popupClass: "b-popup-style",
      allowBackgroundScrolling: true,
      disableClosingOnClickOutside: true,
      popupBackground: "#FFFFFF",
      popupRadius: "20px"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('LOGIN.TXT')), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", {
          class: "h-mt-15",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addCompanyNameToState && _ctx.addCompanyNameToState(...args)), ["enter"]))
        }, [
          _createVNode(_component_FwFormInput, {
            class: "h-mb-30 qa-company-input-wrapper",
            fieldHasError: _ctx.fieldHasErrorByRule(_ctx.company_name, "company_name", _ctx.companyNameRules),
            labelType: "label-thin",
            title: _ctx.$t(`LOGIN.COMPANY.LABEL`)
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_FwInput, {
                value: _ctx.company_name,
                type: "text",
                name: "text",
                inputStyle: "gray",
                placeholder: _ctx.$t(`LOGIN.COMPANY.PLACEHOLDER`),
                error: _ctx.getFieldErrorTextByRule(_ctx.company_name, "company_name", _ctx.companyNameRules),
                onUpdate: _cache[0] || (_cache[0] = value => _ctx.company_name = value),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addCurrentInputToValidateArray("company_name")))
              }, null, 8, ["value", "placeholder", "error"]), [
                [_directive_focus, true]
              ])
            ]),
            _: 1
          }, 8, ["fieldHasError", "title"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FwButton, {
              disabled: !_ctx.isFormValid,
              class: "qa-company-submit",
              borderRadiusType: "small-border",
              onClick: _ctx.addCompanyNameToState
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.NEXT')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["max-width"])
  ]))
}